// In production, VITE_API_URL should be set to the full API URL (e.g., https://api.edframe.app)
// In development, we use the Vite proxy which routes /api to localhost:3300
const API_BASE = import.meta.env.VITE_API_URL || '/api';

class ApiClient {
  async request(endpoint, options = {}) {
    const token = localStorage.getItem('authToken');

    const config = {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
      },
    };

    const response = await fetch(`${API_BASE}${endpoint}`, config);

    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem('authToken');
        window.location.href = '/';
      }

      // Handle rate limiting
      if (response.status === 429) {
        const error = await response.json().catch(() => ({ error: 'Too many requests' }));
        const retryAfter = error.retryAfter || 60;
        const minutes = Math.ceil(retryAfter / 60);

        // Import toast dynamically to avoid circular dependencies
        import('./toast.js').then(({ showToast }) => {
          showToast.error(
            `Too many requests. Please wait ${minutes} minute${minutes > 1 ? 's' : ''} before trying again.`
          );
        });

        throw new Error(error.message || 'Rate limit exceeded');
      }

      const error = await response.json().catch(() => ({ error: 'Request failed' }));
      throw new Error(error.error || error.message || 'Request failed');
    }

    return response.json();
  }

  get(endpoint) {
    return this.request(endpoint, { method: 'GET' });
  }

  post(endpoint, data) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  put(endpoint, data) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  patch(endpoint, data) {
    return this.request(endpoint, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  }

  delete(endpoint) {
    return this.request(endpoint, { method: 'DELETE' });
  }
}

export const api = new ApiClient();

